import { render, staticRenderFns } from "./CustomRTMPForm.vue?vue&type=template&id=5c42a612&scoped=true&"
import script from "./CustomRTMPForm.vue?vue&type=script&lang=js&"
export * from "./CustomRTMPForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomRTMPForm.vue?vue&type=style&index=0&id=5c42a612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c42a612",
  null
  
)

export default component.exports